import React, { Component } from 'react';

export default class SwitchTenantModalRuleForm extends Component {
  state = {
    role: this.props.paramRow.role,
    page: this.props.paramRow.page,
  };

  onChange = ({ target: { name, value, type, checked } }) => {
    const finalValue = type === 'checkbox' ? checked : value;

    this.setState({
      ...this.state,
      [name]: finalValue,
    });
    this.props.paramRow[name] = finalValue;
    this.props.createNewRow(this.props.paramRow);
  };

  onCustomSelectChange = (name, value) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
    this.props.paramRow[name] = value;
    this.props.createNewRow(this.props.paramRow);
  };

  render() {
    return (
      <tr>
        <td>
          <select
            name="role"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.role}
          >
            <option value="">- Select One -</option>
            {this.props.roleOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
        <td>
          <select
            name="page"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.page}
          >
            <option value="">- Select One -</option>
            {this.props.pageOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
      </tr>
    );
  }
}
